import toast from 'react-hot-toast';
import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

export const useExecutePlantScriptMutation = ({
  onSuccess,
}: {
  onSuccess?: (data: unknown) => void;
} = {}) => {
  return useMutation({
    mutationFn: async ({
      plantId,
      formId,
      formData,
    }: {
      plantId: string | undefined;
      formId: string;
      formData: Record<string, unknown>;
    }) => {
      const { data } = await client.post(`/plants/${plantId}/control-panel`, {
        script: {
          [formId]: formData,
        },
      });

      toast.success(`Execute script successfully sent`);
      return data.body;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
  });
};
